import { produce } from 'immer';

import { ShowInternalBannerEditRequestError } from '../../../actions/bannersEdit/internal/showInternalBannerEditRequestError';
import { PageStatus } from '../../../typings/common';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function showInternalBannerEditRequestError(
    state: EditInternalBannersState,
    action: ShowInternalBannerEditRequestError
): EditInternalBannersState {
    return produce(state, draft => {
        draft.pageStatus = PageStatus.ERROR;

        if (draft.errors) {
            draft.errors.push(action.error);
        } else {
            draft.errors = [action.error];
        }
    });
}
